import { Segmented, Input, Form } from 'antd';
import { useCallback, useEffect, useRef, useState } from 'react';
import { OrganizationFields } from './OrganizationFields';
import { AddNotificationTimes } from './AddNotificationTimes';
import { Button } from '../../../baseComponents';
import '../Organization/Organization.scss';
import { BackIconMobile, WarningOrgIcon } from 'src/icons';
import { useNavigate } from 'react-router-dom';
import EmailEditor from './EmailEditor';
import UploadImages from './UploadImages';
import OrgJsonEditor from './OrgJsonEditor';
import { useSelector } from 'react-redux';
import {
  editOrganizationAction,
  ehrFilterOrganizationAction,
  getOrganizationByIdAction,
  uploadOrganizationLogoAction,
} from 'src/modules/SuperAdmin/store/actions/organization.action';
import { Bars } from 'react-loader-spinner';
import { getFromStorage } from 'src/lib/storage';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import * as Yup from 'yup';
import { PatientSummaryNotificationSetting } from './PatientSummaryNotificationSetting';
import { savePatientSummaryNotificationSetting } from 'src/modules/SuperAdmin/store/actions/organization.action';

const { TextArea } = Input;

export const EditOrganizationPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { currentPractitioner } = useSelector(
    (state) => state?.practitionerState
  );

  const storedOrganizationDetails = getFromStorage(
    `${currentPractitioner?.org_uuid}_selectedOrgId`
  );
  const { getOrganizationById, ehrFilterOrganizationList } =
    useSelector((state) => state?.organizationState) ||
    storedOrganizationDetails;

  const [form] = Form.useForm();
  const cachedUserEmail = getFromStorage(`user_email`);
  const isMobile = window.innerWidth < 1260;
  const [showEditor, setShowEditor] = useState(true);
  const [selectedSegment, setSelectedSegment] = useState('logo');
  const [store_BE_Start_hour, setStore_BE_Start_hour] = useState('');
  const [store_BE_End_hour, setStore_BE_End_hour] = useState('');
  const [jsonInput, setJsonInput] = useState('{}');
  const [smsContent, setSmsContent] = useState('');
  const [subjectEditorContent, setSubjectEditorContent] = useState('');
  const [subjectContent, setSubjectContent] = useState('');
  const [emailContent, setEmailContent] = useState('');
  const [bodyEditorContent, setBodyEditorContent] = useState('');
  const [storedAreaCode, setStoredAreaCode] = useState([]);
  const [preferredAreaCodes, setPreferredAreaCodes] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);
  const [logoUrl, setLogoUrl] = useState(null);
  const [editingMode, setEditingMode] = useState('subject');
  const [isValidJson, setIsValidJson] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');
  const [submitInValidJson, setSubmitInValidJson] = useState(false);
  const formikFormRef = useRef();
  const handleSegmentChange = (segment) => {
    setSelectedSegment(segment);
    setEditingMode('subject');
    if (segment === 'logo') {
      setShowEditor(true);
    } else {
      setShowEditor(false);
    }
  };

  const validationSchema = Yup.object().shape({
    ehr_id: Yup.string().required('EHR system is required'),
  });

  useEffect(() => {
    dispatch(getOrganizationByIdAction(storedOrganizationDetails, null, null));
    dispatch(ehrFilterOrganizationAction());
  }, [dispatch, storedOrganizationDetails]);

  useEffect(() => {
    if (getOrganizationById?.organization_details) {
      const jsonInput =
        getOrganizationById?.organization_details?.settings &&
        JSON.stringify(
          getOrganizationById.organization_details.settings,
          null,
          2
        );
      setJsonInput(jsonInput);

      const smsContent =
        getOrganizationById.organization_details.sms?.[0]?.body || null;
      setSmsContent(smsContent);
    }
  }, [getOrganizationById]);

  useEffect(() => {
    if (getOrganizationById?.organization_details) {
      const subjectContent =
        getOrganizationById.organization_details.email?.[0]?.subject || null;
      setSubjectContent(subjectContent);
    }
  }, [getOrganizationById]);

  useEffect(() => {
    if (getOrganizationById?.organization_details) {
      const emailContent =
        getOrganizationById.organization_details.email?.[0]?.body || null;
      setEmailContent(emailContent);
    }
  }, [getOrganizationById]);

  useEffect(() => {
    if (getOrganizationById?.organization_details) {
      const logoUrl = getOrganizationById.organization_details?.logo_url;
      setLogoUrl(logoUrl);
    }
  }, [getOrganizationById]);

  // Notification time states
  const [notificationStartHour, setNotificationStartHour] = useState('');
  const [notificationStartMinute, setNotificationStartMinute] = useState('');
  const [notificationEndHour, setNotificationEndHour] = useState('');
  const [notificationEndMinute, setNotificationEndMinute] = useState('');
  const [notificationStartRadio, setNotificationStartRadio] = useState(null);
  const [notificationEndRadio, setNotificationsEndRadio] = useState(null);
  const [notificationSetting, setNotificationSetting] = useState(null);

  useEffect(() => {
    const browserTimezone = moment.tz.guess();
    const startHour =
      getOrganizationById?.organization_details?.notification_start_time || '';
    const endHour =
      getOrganizationById?.organization_details?.notification_end_time || '';

    setStore_BE_Start_hour(startHour);
    setStore_BE_End_hour(endHour);

    if (startHour && endHour) {
      const [split_start_hour, split_start_minute] = startHour.split(':');
      const [split_end_hour, split_end_minute] = endHour.split(':');

      const startMoment = moment
        .utc(`${split_start_hour}:${split_start_minute}`, 'HH:mm')
        .tz(browserTimezone);
      const endMoment = moment
        .utc(`${split_end_hour}:${split_end_minute}`, 'HH:mm')
        .tz(browserTimezone);

      const local_start_hours = startMoment.hours();
      const local_end_hours = endMoment.hours();

      let default_start_hour = local_start_hours;
      let default_end_hour = local_end_hours;

      if (default_start_hour) {
        const parsedHour = parseInt(default_start_hour);
        if (!isNaN(parsedHour) && parsedHour >= 0 && parsedHour <= 11) {
          setNotificationStartRadio(1);
        } else {
          setNotificationStartRadio(2);
        }
      }

      if (default_end_hour) {
        const parsedHour = parseInt(default_end_hour);
        if (!isNaN(parsedHour) && parsedHour >= 0 && parsedHour <= 11) {
          setNotificationsEndRadio(1);
        } else {
          setNotificationsEndRadio(2);
        }
      }

      if (local_start_hours === 0) {
        default_start_hour = 12; // Midnight is represented as 12 AM
      } else if (local_start_hours > 12) {
        default_start_hour = local_start_hours - 12;
      }

      if (local_end_hours === 0) {
        default_end_hour = 12; // Midnight is represented as 12 AM
      } else if (local_end_hours > 12) {
        default_end_hour = local_end_hours - 12;
      }

      setNotificationStartMinute(
        startMoment.minutes() < 10
          ? '0' + startMoment.minutes()
          : startMoment.minutes()
      );
      setNotificationStartHour(default_start_hour);

      setNotificationEndMinute(
        endMoment.minutes() < 10
          ? '0' + endMoment.minutes()
          : endMoment.minutes()
      );
      setNotificationEndHour(default_end_hour);
    }
  }, [getOrganizationById]);

  const formatting_Time = (hour, meredien) => {
    const am_pm_Radio =
      meredien === 'start' ? notificationStartRadio : notificationEndRadio;
    if (am_pm_Radio === 2 && hour !== 12) {
      hour += 12;
    }
    if (am_pm_Radio === 1 && hour === 12) {
      hour = 0;
    }
    return hour;
  };

  useEffect(() => {
    if (notificationStartHour === 12 && notificationStartRadio === null) {
      setNotificationStartRadio(1);
    }

    if (notificationEndHour === 12 && notificationEndRadio === null) {
      setNotificationsEndRadio(1);
    }
  }, [
    notificationStartHour,
    notificationEndHour,
    notificationStartRadio,
    notificationEndRadio,
  ]);

  const [orgData, setOrgData] = useState({});

  useEffect(() => {
    if (getOrganizationById?.organization_details) {
      const initialValues = {
        logoUUID: uuidv4(),
        org_name: getOrganizationById?.organization_details?.org_name || '',
        ehr_id: getOrganizationById?.organization_details?.ehr_id || '',
        comm_id: getOrganizationById?.organization_details?.comm_id || '',
        allowed_domains:
          getOrganizationById?.organization_details?.allowed_domains || '',
        website: getOrganizationById?.organization_details?.website || '',
        settings: getOrganizationById?.organization_details?.settings || '',
        logo_url: getOrganizationById?.organization_details?.logo_url || '',
        phone_data: {
          phone_text:
            getOrganizationById?.organization_details?.phone_data?.phone_text ||
            '',
          phone_type:
            getOrganizationById?.organization_details?.phone_data?.phone_type ||
            '',
        },
        email_data: {
          email_text:
            getOrganizationById?.organization_details?.email_data?.email_text ||
            '',
          email_type:
            getOrganizationById?.organization_details?.email_data?.email_type ||
            '',
        },
        sms: {
          subject:
            getOrganizationById?.organization_details?.sms?.subject || '',
          body: getOrganizationById?.organization_details?.sms?.body || '',
        },
        frontegg_plan_id:
          getOrganizationById?.organization_details?.frontegg_plan_id,
        address: {
          line_1:
            getOrganizationById?.organization_details?.address?.line_1 || '',
          line_2:
            getOrganizationById?.organization_details?.address?.line_2 || '',
          zip: getOrganizationById?.organization_details?.address?.zip || '',
          city: getOrganizationById?.organization_details?.address?.city || '',
          state:
            getOrganizationById?.organization_details?.address?.state || '',
          country:
            getOrganizationById?.organization_details?.address?.country || '',
        },
        org_setting_start_time:
          getOrganizationById?.organization_details?.org_setting_start_time ||
          '',
        org_setting_end_time:
          getOrganizationById?.organization_details?.org_setting_end_time || '',
        create_frontegg_account:
          getOrganizationById?.organization_details?.create_frontegg_account ||
          '',
        last_modified_by: cachedUserEmail,
        preferred_phone_area_codes:
          getOrganizationById?.organization_details
            ?.preferred_phone_area_codes || '',
      };
      setOrgData(initialValues);
    }
  }, [getOrganizationById, cachedUserEmail]);

  const handleSubmit = () => {
    if (!isValidJson) {
      setSubmitInValidJson(true);
      return;
    }
    if (formikFormRef.current) {
      formikFormRef.current.handleSubmit();
      if (preferredAreaCodes.length == 0) {
        document
          .querySelector('[name="preferred_phone_area_codes_requiredMsg"]')
          .classList.remove('hidden');
      }
      formikFormRef.current.validateForm().then(() => {
        if (
          Object.keys(formikFormRef.current.errors).length === 0 &&
          preferredAreaCodes.length !== 0
        ) {
          formSubmitAction();
        }
      });
    }
  };

  const formSubmitAction = () => {
    const browserTimezone = moment.tz.guess();
    // Notification Start time conversion : Starts
    const startHour = parseInt(notificationStartHour);
    const startMinute = parseInt(notificationStartMinute);
    let formatted_start_hour = startHour;
    const start_time = formatting_Time(formatted_start_hour, 'start');
    const formatted_Start_Time = moment.tz(
      { hour: start_time, minute: startMinute },
      browserTimezone
    );
    const final_Start_Time = formatted_Start_Time.utc().format('HH:mm');
    //Notification Start time conversion : Ends

    // Notification End time : Starts
    const endHour = parseInt(notificationEndHour);
    const endMinute = parseInt(notificationEndMinute);
    let formatted_end_hour = endHour;
    const end_time = formatting_Time(formatted_end_hour, 'end');
    const formatted_End_Time = moment.tz(
      { hour: end_time, minute: endMinute },
      browserTimezone
    );
    const final_End_Time = formatted_End_Time.utc().format('HH:mm');
    // Ends
    const convertCodeToInt = preferredAreaCodes?.map((code) => parseInt(code));
    const updatedOrgData = {
      ...orgData,
      org_name: orgData?.org_name,
      ehr_id: orgData?.ehr_id,
      comm_id: null,
      allowed_domains: orgData?.allowed_domains,
      website: orgData?.website,
      settings: jsonInput && JSON.parse(jsonInput),
      logo_url: orgData?.logo_url,
      logo_file: '',
      logo_type: '',
      phone_data: {
        phone_text: orgData?.phone_data?.phone_text,
        phone_type: '',
      },
      email_data: {
        email_text: orgData?.email_data?.email_text,
        email_type: '',
      },
      sms: {
        subject: '',
        body: smsContent,
      },
      address: {
        line_1: orgData?.address?.line_1,
        line_2: orgData?.address?.line_2,
        city: orgData?.address?.city,
        state: orgData?.address?.state,
        zip: orgData?.address?.zip,
        country: orgData?.address?.country,
        address_type: '',
      },
      org_setting_start_time: final_Start_Time,
      org_setting_end_time: final_End_Time,
      create_frontegg_account: true,
      created_by: cachedUserEmail,
      preferred_phone_area_codes: convertCodeToInt ? convertCodeToInt : null,
    };
    dispatch(
      savePatientSummaryNotificationSetting({
        org_uuid: getOrganizationById?.organization_details?.org_uuid,
        enabled: notificationSetting,
      })
    );
    if (selectedFile) {
      dispatch(
        uploadOrganizationLogoAction(
          {
            file_name: `${orgData.logoUUID}.${selectedFile?.ext}`,
            logo: selectedFile,
          },
          navigate,
          updatedOrgData,
          'isEditPage',
          getOrganizationById?.organization_details?.org_id
        )
      );
    } else {
      dispatch(
        editOrganizationAction(
          getOrganizationById?.organization_details?.org_id,
          updatedOrgData,
          navigate
        )
      );
    }
  };
  useEffect(() => {
    const organizationDetails = getOrganizationById?.organization_details;
    if (organizationDetails) {
      const areaCodes = organizationDetails?.preferred_phone_area_codes || null;
      setPreferredAreaCodes(areaCodes);
    }
  }, [getOrganizationById]);

  const updateSettingsJson = useCallback((jsonData) => {
    setOrgData((prevOrgData) => ({
      ...prevOrgData,
      settings: jsonData,
    }));
  }, []);

  const updateLogoUrl = (url) => {
    setOrgData((prevOrgData) => ({
      ...prevOrgData,
      logo_url: url,
      logo_file: null,
      logo_type: null,
    }));
  };

  const handleBlobSelect = useCallback((blob) => {
    setSelectedFile(blob);
    setOrgData((prevOrgData) => ({
      ...prevOrgData,
      logo_url: null,
      logo_file: {
        ...blob,
        size: blob.size,
        type: blob.type,
      },
    }));
  }, []);
  return getOrganizationById?.organization_details ? (
    <div className={`page-wrapper`}>
      <div className="">
        <BackIconMobile onClick={() => navigate('/superadmin')} />
      </div>
      <div className={isMobile ? '' : 'flex gap-4'}>
        <div className="lg:w-1/2">
          {/* AddOrganization & Address fields*/}
          <div className="bg-white px-4 py-2 rounded-2xl mt-2 pt-4">
            <OrganizationFields
              ref={formikFormRef}
              storedAreaCode={storedAreaCode}
              setStoredAreaCode={setStoredAreaCode}
              isEditPage={true}
              orgData={orgData}
              setOrgData={setOrgData}
              ehrFilterOrganizationList={ehrFilterOrganizationList}
              setPreferredAreaCodes={setPreferredAreaCodes}
              preferredAreaCodes={preferredAreaCodes}
              inputValue={inputValue}
              setInputValue={setInputValue}
              validationSchema={validationSchema}
            />
          </div>

          {/* Notifications time  */}
          <div className="bg-white  rounded-2xl mt-5">
            <AddNotificationTimes
              isEditPage={true}
              form={form}
              notificationStartHour={notificationStartHour}
              setNotificationStartHour={setNotificationStartHour}
              notificationStartMinute={notificationStartMinute}
              setNotificationStartMinute={setNotificationStartMinute}
              notificationEndHour={notificationEndHour}
              setNotificationEndHour={setNotificationEndHour}
              notificationEndMinute={notificationEndMinute}
              setNotificationEndMinute={setNotificationEndMinute}
              notificationStartRadio={notificationStartRadio}
              setNotificationStartRadio={setNotificationStartRadio}
              notificationEndRadio={notificationEndRadio}
              setNotificationsEndRadio={setNotificationsEndRadio}
            />
          </div>
          <div className="bg-white  rounded-2xl mt-5">
            <PatientSummaryNotificationSetting
              org_uuid={getOrganizationById?.organization_details?.org_uuid}
              notificationSetting={notificationSetting}
              setNotificationSetting={setNotificationSetting}
            />
          </div>
        </div>

        <div className="lg:w-1/2 organization">
          <div className="h-[40rem] bg-white px-4 py-2 rounded-2xl mt-2 segmented_schedule">
            <Segmented
              defaultValue="logo"
              onChange={handleSegmentChange}
              options={[
                { label: 'Logo upload', value: 'logo' },
                { label: 'SMS editor', value: 'sms' },
                {
                  label: (
                    <div className="flex items-center justify-center">
                      <span className="mr-2">Settings</span>
                      <span>
                        {!isValidJson && submitInValidJson && (
                          <WarningOrgIcon />
                        )}
                      </span>
                    </div>
                  ),
                  value: 'settings',
                },
              ]}
            />
            {showEditor && selectedSegment === 'logo' ? (
              <div className="container mx-auto py-2">
                {/* <DndProvider backend={HTML5Backend}> */}
                <UploadImages
                  isEditPage={true}
                  updateLogoUrl={updateLogoUrl}
                  selectedFile={selectedFile}
                  setSelectedFile={setSelectedFile}
                  handleBlobSelect={handleBlobSelect}
                  logoUrl={logoUrl}
                  setLogoUrl={setLogoUrl}
                  setOrgData={setOrgData}
                  orgData={orgData}
                  fromAddPage={false}
                />
              </div>
            ) : selectedSegment === 'editor' ? (
              <>
                <EmailEditor
                  subjectContent={subjectContent}
                  setSubjectContent={setSubjectContent}
                  subjectEditorContent={subjectEditorContent}
                  setSubjectEditorContent={setSubjectEditorContent}
                  emailContent={emailContent}
                  setHtmlContent={setEmailContent}
                  bodyEditorContent={bodyEditorContent}
                  setBodyEditorContent={setBodyEditorContent}
                  editingMode={editingMode}
                  setEditingMode={setEditingMode}
                />
              </>
            ) : selectedSegment === 'sms' ? (
              <div className="h-[35rem] border-2 border-[#ccc] rounded-lg mt-4">
                <div className="grid grid-cols-1 gap-4 mt-2 ">
                  <TextArea
                    bordered={false}
                    rows={24}
                    placeholder="Add sms editor."
                    style={{
                      resize: 'none',
                      fontFamily: 'Poppins',
                    }}
                    value={smsContent}
                    onChange={(e) => setSmsContent(e.target.value)}
                  />
                </div>
              </div>
            ) : (
              <div>
                <OrgJsonEditor
                  jsonInput={jsonInput}
                  setJsonInput={setJsonInput}
                  updateSettingsJson={updateSettingsJson}
                  isValidJson={isValidJson}
                  setIsValidJson={setIsValidJson}
                  errorMessage={errorMessage}
                  setErrorMessage={setErrorMessage}
                />
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="flex justify-center items-center mt-4">
        <Button type={'button'} onClick={handleSubmit}>
          Submit
        </Button>
      </div>
    </div>
  ) : (
    <Bars
      height="25"
      width="25"
      color="#00d091"
      ariaLabel="bars-loading"
      wrapperStyle={{}}
      wrapperClass=" justify-center"
      visible={true}
    />
  );
};
